import React, { useState } from "react";

const Faq = () => {
  const [activeId, setActiveId] = useState("collapseOne");

  const handleToggle = (id) => {
    setActiveId(activeId === id ? "" : id);
  };

  const Faqsdata = [
    {
      id: "collapseOne",
      heading: "headingOne",
      question: "Waktu Proses",
      answer:
        "Logo woven 3-4 hari kerja<br>Laser cutiing 1-2 hari kerja<br>neci 7 - 14 hari kerja",
    },
    {
      id: "collapseTwo",
      heading: "headingTwo",
      question:
        "Berapa banyak warna yang dapat di implementasi pada logo woven ?",
      answer: "Maksimal 8 warna.",
    },

    {
      id: "collapseFour",
      heading: "headingFour",
      question: "Bisakah saya menggunakan desain saya sendiri?",
      answer: "Ya, Anda dapat menggunakan desain sendiri",
    },
    {
      id: "collapseFive",
      heading: "headingFive",
      question: "Apakah mina logo dapat mengirimkan ke negara lain",
      answer: "Ya, Mina Label mengirim ke negara lain.",
    },
    {
      id: "collapseSix",
      heading: "headingSix",
      question: "Apakah ini pabrik manufaktur?",
      answer:
        "Ya kami merupakan pabrik manufaktur untuk logo woven, dan selain itu kami juga dapat memproduksi label woven, satin printing, katun printing dan tafeta.",
    },
    {
      id: "collapseSeven",
      heading: "headingSeven",
      question: "Apakah bisa di bantu jika kami belum memiliki design?",
      answer:
        "Ya, anda cukup memberikan detail draft dan kami bisa membantu design.",
    },
    {
      id: "collapseEight",
      heading: "headingEight",
      question: "Bagaimana cara pembayaran?",
      answer: "Anda dapat melakukan pembayaran melalui transfer bank.",
    },
    {
      id: "collapseNine",
      heading: "headingNine",
      question: "Apakah Anda menerima reseller atau afiliasi?",
      answer:
        "Ya, kami menerima reseller atau afiliasi, silakan hubungi kami untuk informasi lebih lanjut.",
    },
  ];

  return (
    <>
      <section className="row_am faq_section" id="faqsec">
        <div className="container">
          <div
            className="section_title"
            data-aos="fade-up"
            data-aos-duration={1500}
          >
            <span className="title_badge">Question &amp; Answer</span>
            <h2>FAQs - Frequently Asked Questions</h2>
          </div>
          <div
            className="faq_blocks"
            data-aos="fade-up"
            data-aos-duration={1500}
          >
            <div className="accordion" id="accordionExample">
              <div className="row">
                <div className="col-md-6">
                  {Faqsdata.slice(0, 4).map((faq) => (
                    <div className="card" key={faq.id}>
                      <div className="card-header" id={faq.heading}>
                        <h5 className="mb-0">
                          <button
                            className={`btn btn-link btn-block text-left ${
                              activeId === faq.id ? "" : "collapsed"
                            }`}
                            type="button"
                            onClick={() => handleToggle(faq.id)}
                            aria-expanded={activeId === faq.id}
                            aria-controls={faq.id}
                          >
                            {faq.question}
                            <span className="icons">
                              {activeId === faq.id ? (
                                <i className="icofont-minus" />
                              ) : (
                                <i className="icofont-plus" />
                              )}
                            </span>
                          </button>
                        </h5>
                      </div>
                      <div
                        id={faq.id}
                        className={`collapse ${
                          activeId === faq.id ? "show" : ""
                        }`}
                        aria-labelledby={faq.heading}
                        data-parent="#accordionExample"
                      >
                        <div className="card-body">
                          {faq.answer.split("<br>").map((line, index) => (
                            <p
                              key={index}
                              style={{ marginBottom: "0", marginTop: "0" }}
                            >
                              {line}
                            </p>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="col-md-6">
                  {Faqsdata.slice(4, 9).map((faq) => (
                    <div className="card" key={faq.id}>
                      <div className="card-header" id={faq.heading}>
                        <h5 className="mb-0">
                          <button
                            className={`btn btn-link btn-block text-left ${
                              activeId === faq.id ? "" : "collapsed"
                            }`}
                            type="button"
                            onClick={() => handleToggle(faq.id)}
                            aria-expanded={activeId === faq.id}
                            aria-controls={faq.id}
                          >
                            {faq.question}
                            <span className="icons">
                              {activeId === faq.id ? (
                                <i className="icofont-minus" />
                              ) : (
                                <i className="icofont-plus" />
                              )}
                            </span>
                          </button>
                        </h5>
                      </div>
                      <div
                        id={faq.id}
                        className={`collapse ${
                          activeId === faq.id ? "show" : ""
                        }`}
                        aria-labelledby={faq.heading}
                        data-parent="#accordionExample"
                      >
                        <div className="card-body">
                          {faq.answer.split("<br>").map((line, index) => (
                            <p
                              key={index}
                              style={{ marginBottom: "0", marginTop: "0" }}
                            >
                              {line}
                            </p>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Faq;
